import { render, staticRenderFns } from "./BaseSkeletonLoader.vue?vue&type=template&id=4ff21b15&scoped=true&"
import script from "./BaseSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./BaseSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./BaseSkeletonLoader.vue?vue&type=style&index=0&id=4ff21b15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff21b15",
  null
  
)

export default component.exports